exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".full-calendar-header{display:flex;align-items:center}.header-center{flex:3;text-align:center}.title{text-align:center;font-size:1.5em;font-weight:bolder}.language-select{display:inline-block;width:50%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-5a74c6e0","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/Components/Header.vue
// module id = 138
// module chunks = 0 1